const getToken = () => localStorage.getItem("admin_crypto");

export const AdminAuthCheck = async () => {
  const token = getToken();
  try {
    const resp = await fetch("/admin/auth/check", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Admin Auth Check" + error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const AdminLogin = async (body) => {
  try {
    const resp = await fetch("/admin/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.error("Admin Login" + error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const updateAdminPw = async (body) => {
  const token = getToken();

  try {
    const resp = await fetch(`/admin/change/pw`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Whitelist CapMode
export const getWhitelist = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event/admin/get${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Whitelist Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/* ➕ POST – Add / Upsert cap + pid */
export const addWhitelist = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch("/api/event/admin/add", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { p_id }
    });
    return await resp.json();
  } catch (error) {
    console.error("Add Whitelist Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/* ➕ POST – Add PID to existing cap */
export const updateWhitelistStatus = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch("/api/event/admin/status", {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { p_id, isActive }
    });
    return await resp.json();
  } catch (error) {
    console.error("Update Status Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/**
 * 🗑️ DELETE whitelist by p_id
 * DELETE /api/event/admin/delete
 */
export const deleteWhitelist = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { ids: [] }
    });
    return await resp.json();
  } catch (error) {
    console.error("Delete Whitelist Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/**
 * ✅ GET ONLY ACTIVE whitelist (all-time)
 * GET /api/event/admin/active
 */
export const getActiveWhitelist = async () => {
  const token = getToken();
  try {
    const resp = await fetch("/api/event/admin/active", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Active Whitelist Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/* ➕ GET – Unique Campaign Names for Filter */
export const getCampaignNames = async () => {
  const token = getToken();
  try {
    const resp = await fetch("/api/event/admin/campaigns", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Campaign Names Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const getEventDashboard = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event-tracker/admin/dashboard${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Event Dashboard Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const getEventList = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event-tracker/admin/list${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Event List Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const updateEventStatus = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event-tracker/admin/status`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { p_id, isActive }
    });
    return await resp.json();
  } catch (error) {
    console.error("Update Event Status Error", error);
    return { status: false, message: "Internet Server Error" };
  }
}

export const deleteTrackEvent = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event-tracker/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { ids: [] }
    });
    return await resp.json();
  } catch (error) {
    console.error("Delete Track Event Error", error);
    return { status: false, message: "Internet Server Error" };
  }
}

// User Management
/**
 * 📋 GET users with filters
 * GET /api/user/admin?search=&u_pid=&u_device=&startDate=&endDate=&filterType=&block=&page=&limit=
 */
export const getUsers = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Users Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/**
 * 🗑️ DELETE users by IDs
 * DELETE /api/user/admin
 */
export const deleteUsers = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { ids: [] }
    });
    return await resp.json();
  } catch (error) {
    console.error("Delete Users Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/**
 * 👤 GET user by ID
 * GET /api/user/admin/data/:id
 */
export const getUserById = async (id) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin/data/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get User By ID Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

// Purchase Management
/**
 * 📋 GET purchase history with filters
 * GET /api/user/admin/purchase/list?search=&p_type=&startDate=&endDate=&page=&limit=
 */
export const getPurchaseHistory = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin/purchase/list${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Purchase History Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/**
 * 🗑️ DELETE purchases by IDs
 * DELETE /api/user/admin/purchase/delete
 */
export const deletePurchases = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin/purchase/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { ids: [] }
    });
    return await resp.json();
  } catch (error) {
    console.error("Delete Purchases Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/**
 * 👤 GET purchases by user ID
 * GET /api/user/admin/purchase/history/:id?page=&limit=
 */
export const getUserPurchases = async (id, params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin/purchase/history/${id}${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get User Purchases Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const userBlock = async (id) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin/block/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("User Block Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const purchaseDashboard = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin/purchase/dashboard${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Purchase Dashboard Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const userDashboard = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/user/admin/user/dashboard${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("User Dashboard Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};
